import { UPLOAD_FILE_SIZES } from '@config/upload-file-sizes.ts';
import { IMimeTypeFileSizes } from '@konova/ui/upload';

export const MIME_TYPE_FILE_SIZES: Partial<IMimeTypeFileSizes> = {
  IMAGE: UPLOAD_FILE_SIZES.images.bytes,
  SVG: UPLOAD_FILE_SIZES.images.bytes,
  PDF: UPLOAD_FILE_SIZES.documents.bytes,
  DOC: UPLOAD_FILE_SIZES.documents.bytes,
  CSV: UPLOAD_FILE_SIZES.documents.bytes,
  FONT: UPLOAD_FILE_SIZES.fonts.bytes,
  TXT: UPLOAD_FILE_SIZES.documents.bytes,
  XLS: UPLOAD_FILE_SIZES.documents.bytes,
  XLSX: UPLOAD_FILE_SIZES.documents.bytes,
};
